import { Node } from "reactflow";

export function filterByZapNodes(nodes: Node[]) {
  return nodes.filter((node) => node.type === "zap");
}
